import { render } from "./my-templates.vue?vue&type=template&id=ed714624&scoped=true&ts=true"
import script from "./my-templates.vue?vue&type=script&lang=ts"
export * from "./my-templates.vue?vue&type=script&lang=ts"

import "./my-templates.vue?vue&type=style&index=0&id=ed714624&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed714624"]])

export default __exports__